module.exports = __webpack_public_path__ + "img/Weapon_252.1ed1a206.png";